var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSessions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8444 7.5H14.1667C9.91111 7.5 7.5 9.91111 7.5 14.1667V25.8333C7.5 30.0889 9.91111 32.5 14.1667 32.5H25.8444C30.1 32.5 32.5 30.0889 32.5 25.8333V14.1667C32.5 9.91111 30.1 7.5 25.8444 7.5Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2111 16.7109C13.6444 16.7109 13.1777 17.1776 13.1777 17.7554V26.3443C13.1777 26.9109 13.6444 27.3776 14.2111 27.3776C14.7888 27.3776 15.2555 26.9109 15.2555 26.3443V17.7554C15.2555 17.1776 14.7888 16.7109 14.2111 16.7109Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0451 12.6094C19.4784 12.6094 19.0117 13.076 19.0117 13.6538V26.3427C19.0117 26.9094 19.4784 27.376 20.0451 27.376C20.6228 27.376 21.0895 26.9094 21.0895 26.3427V13.6538C21.0895 13.076 20.6228 12.6094 20.0451 12.6094Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8003 21.2461C25.2225 21.2461 24.7559 21.7128 24.7559 22.2905V26.3461C24.7559 26.9128 25.2225 27.3794 25.7892 27.3794C26.367 27.3794 26.8336 26.9128 26.8336 26.3461V22.2905C26.8336 21.7128 26.367 21.2461 25.8003 21.2461Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessions);
export default __webpack_public_path__ + "static/media/sessions.1298c6e6d92e0e4d82ec415f2b2d4a78.svg";
export { ForwardRef as ReactComponent };